import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusEmployeeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [EmployeeStatusOptions, setEmployeeStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { employeeStatus, setEmployeeStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setEmployeeStatus(
      parameters?.data?.filter((item) => item.type === "employeeStatus")
    );
  }, [parameters]);

  useEffect(() => {
    setEmployeeStatusOptions(
      employeeStatus.map((item: Parameter) => ({
        label: item.value,
        value: item.value === "Ativo" ? "true" : "false",
      }))
    );
  }, [employeeStatus]);

  return (
    <Dropdown
      value={options.value}
      options={EmployeeStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status..."
      showClear
    />
  );
};
export default StatusEmployeeDropdown;
